$shm_hitalama_settings_agent $mol_book2_catalog
	param \agent_config
	menu_title \Агент
	menu_body /
		<= Current_label $mol_labeler
			title \Активная конфигурация ИИ-агента
			Content <= Current $mol_select
				value? <=> current? \
				dictionary <= config_dictionary *
		<= Configs_label $mol_labeler
			title \Список конфигураций
			Content <= Menu_links
		<= Add $mol_button_major
			title \Добавить конфигурацию
			click? <=> add? null
	Config* $mol_page
		title <= config_name*
		tools / <= Spread_close
		body /
			<= Config_fields* $mol_list
				rows <= config_field_rows* /
					<= Name_label* $mol_labeler
						title \Название
						Content <= Name* $shm_hitalama_settings_agent_string
							input_name <= name_input_name* \
							value? <=> config_name*? \
					<= Backend_label* $mol_labeler
						title \Бэкенд
						Content <= Backend* $mol_select
							value? <=> config_backend*? \opencode
							dictionary <= backend_dictionary *
					<= Connection_label* $mol_labeler
						title \Подключение на этом устройстве
						Content <= Connection* $mol_select
							value? <=> config_connection*? \remote
							dictionary <= connection_dictionary *
					<= Connection_hint* $mol_text
						text <= connection_hint* \
					<= Url_label* $mol_labeler
						title <= url_label* \URL ИИ-агента
						Content <= Url* $shm_hitalama_settings_agent_string
							input_name <= url_input_name* \
							value? <=> config_url*? \
					<= Token_label* $mol_labeler
						title \Токен ИИ-агента
						Content <= Token* $shm_hitalama_settings_agent_password
							input_name <= token_input_name* \
							value? <=> config_token*? \
					<= Mcp_url_label* $mol_labeler
						title <= mcp_url_label* \URL Hitalama MCP
						Content <= Mcp_url* $shm_hitalama_settings_agent_string
							input_name <= mcp_url_input_name* \
							hint <= mcp_url_hint* \wss://example.com/hitalama-mcp
							value? <=> config_mcp_url*? \
					<= Mcp_token_label* $mol_labeler
						title \Токен Hitalama MCP
						Content <= Mcp_token* $shm_hitalama_settings_agent_password
							input_name <= mcp_token_input_name* \
							hint \Если пусто — токен ИИ-агента
							value? <=> config_mcp_token*? \
					<= Check_row* $mol_view
						sub /
							<= Check* $mol_button_minor
								title \Проверить соединение
								enabled <= check_enabled* true
								click? <=> check*? null
							<= Check_status* $mol_paragraph
								title <= check_status* \
								attr *
									^
									hidden <= check_status_hidden* true
									status <= check_status_kind* \
			^ remove_visible* /
				<= Remove* $shm_confirm_delete
					confirmed? <=> remove*? null
